<template>
<div id="app">
  <transition name="fade">
    <ui :isMobile="isMobile" v-if="!showLoader"></ui>
  </transition>
  <!-- <webGlTransition v-if="showTransition"></webGlTransition> -->
  <webGl @cablesLoaded="loaded.cables = $event"></webGl>
  <transition name="fade">
    <div v-if="showTransition" class="scanlines"></div>
  </transition>
  <div style="z-index: 2" class="container">
    <transition appear name="fade">

      <loader :isMobile="isMobile" v-if="showLoader"></loader>
    </transition>
  </div>
  <detailsRight v-if="!isMobile"></detailsRight>
  <detailsLeft v-if="!isMobile"></detailsLeft>
</div>
</template>

<script>
import webGl from './components/webGl.vue'
// import webGlTransition from './components/webGlTransition.vue'
import loader from './components/loader.vue'
import detailsRight from './components/detailsRight.vue'
import detailsLeft from './components/detailsLeft.vue'

import ui from './components/interface.vue'

import isMobile from './isMobile.js'
// window.onload = function() {
//   var context = new AudioContext();
// }

export default {
  data() {
    return {
      isMobile: isMobile.isMobile(),
      showScanlines: true,
      showLoader: true,
      showTransition: true,
      loaded: {
        cables: false,

      }
    }
  },
  name: 'app',
  components: {
    webGl,
    detailsRight,
    detailsLeft,
    loader,
    ui,
    // webGlTransition
  },
  methods: {
    destroyLoader() {
      this.showLoader = false
    }
  },
  mounted() {
    this.$root.$on('startRender', () => {
      this.showScanlines = false
      this.destroyLoader()
      setTimeout(() => {
        this.showTransition = false
      }, 1000)
    })

    console.log("%c...................................................", 'color: lime; font-family: monospace');
    console.log("%cWebGl by www.selam-x.com", 'color: lime; font-family: monospace');
    console.log("%c...................................................", 'color: lime; font-family: monospace');
    console.log("%cArtur Neufeld (https://www.instagram.com/artur.neufeld/)", 'color: lime; font-family: monospace');
    console.log("%cJan Scheurer (http://www.xe-development.com/)", 'color: lime; font-family: monospace');
    console.log("%cPascal M. Wiemers (https://www.instagram.com/pascalmwiemers/)", 'color: lime; font-family: monospace');
    console.log("%cRobert Dietz (https://www.instagram.com/robertdietz/)", 'color: lime; font-family: monospace');
    console.log("%c...................................................", 'color: lime; font-family: monospace');
    console.log("%cmade with www.cables.gl", 'color: lime; font-family: monospace');
    console.log("%c...................................................", 'color: lime; font-family: monospace');

    function check() {
      if (CABLES.patch.cgl.canvas.clientWidth == window.innerWidth && CABLES.patch.cgl.canvas.clientHeight == window.innerHeight)
        return requestAnimationFrame(check);
      CABLES.patch.cgl.setSize(window.innerWidth, window.innerHeight);
      requestAnimationFrame(check);
    }
    check();

  }
}
</script>

<style lang="scss">
.fade-enter-active {
    transition: opacity 0.5s;
}

.fade-leave-active {
    transition: opacity 1.5s;
}
/* .fade-leave-active below version 2.1.8 */
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

body,
html {
    margin: 0;
    overflow: hidden;
    padding: 0;
    height: 100%;

}

body {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    /* hide grey rectangle on iOS touch */
}
::-moz-selection {
    background: transparent;
}
::selection {
    background: transparent;
}
#app {
    font-family: 'Monument Grotesk Mono', "Lucida Console", Monaco, monospace;
    // font-family: 'Monument Grotesk Mono';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
    height: 100%;
    // scroll-behavior: smooth;
    // -webkit-overflow-scrolling: touch;
    // -webkit-transform: translate3d(0,0,0);
    // overflow-y: scroll;
    // overflow-x: hidden;
}

// @mixin scanlines($color, $height: 1px, $angle: 0, $opacity: 0.2) {
//     position: relative;
//     &:after {
//         background-image: repeating-linear-gradient(to bottom, transparent 0, transparent $height, $color $height, $color $height * 2);
//         background-size: 100% $height * 2, cover;
//         transform-origin: 50% 50%;
//         transform: rotate($angle);
//         content: '';
//         opacity: $opacity;
//         position: absolute;
//         top: -150%;
//         left: -150%;
//         right: -150%;
//         bottom: -150%;
//     }
// }

.scanlines {
    // @include scanlines(rgb(20, 30, 20), 2px, 0deg, 0.5);

    position: fixed;
    pointer-events: none; // background: -moz-radial-gradient(center, ellipse cover, rgba(0,255,0,.3) 0%, rgba(255,255,255,0) 100%);
    // /* FF3.6-15 */
    // background: -webkit-radial-gradient(center, ellipse cover, rgba(0,255,0,.3) 0%,rgba(255,255,255,0) 100%);
    /* Chrome10-25,Safari5.1-6 */
    // background: radial-gradient(ellipse at center, rgba(0, 255, 0, .1) 30%, rgba(0, 0, 0, 0) 100%);
    /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    background: black;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-transform: translate3d(0,0,0);
}
</style>
